import * as React from 'react'
import { Pane, Text, Heading, Link, Paragraph, PaneProps } from 'evergreen-ui'
import { useCustomTheme } from '/fiweb/lib/theme'
import { SmallInfoCard } from '/~/components/Cards'
import { useBreakpoint } from '/fiweb/lib'
import { useAuthContext } from '/~/utils/AuthContext'

export const InvestorInfoCards = ({ ...rest }: PaneProps) => {
  const { user } = useAuthContext()
  const { medium, large } = useBreakpoint()
  const theme = useCustomTheme()
  return (
    <Pane
      display='flex'
      flexDirection={medium ? 'column' : 'row'}
      justifyContent={large ? 'space-around' : 'space-between'}
      flexWrap={large ? 'wrap' : 'nowrap'}
      width={medium ? 325 : large ? 700 : 1010}
      marginBottom={medium ? theme.spacing.l : theme.spacing.xl}
      {...rest}
    >
      <SmallInfoCard>
        <Heading size={medium ? 500 : 600} marginBottom={theme.spacing.xs}>
          1.
        </Heading>
        <Heading size={400} marginBottom={theme.spacing.xs}>
          Opprett en investeringsprofil
        </Heading>
        <Paragraph size={400} marginBottom={theme.spacing.xxs}>
          Følg stegene under{' '}
          <Text fontSize={18} lineHeight='28px' fontWeight={medium ? 400 : 600}>
            «ny profil»
          </Text>{' '}
          og følg stegene. Last opp firmaattest dersom du ønsker å investere gjennom et selskap.
        </Paragraph>
        <Link href={user ? '/konto' : '/innlogging/registrering'} fontSize={18} fontWeight={600} lineHeight='36px'>
          Opprett en profil
        </Link>
      </SmallInfoCard>
      <SmallInfoCard>
        <Heading size={medium ? 500 : 600} marginBottom={theme.spacing.xs}>
          2.
        </Heading>
        <Heading size={400} marginBottom={theme.spacing.xs}>
          Utforsk muligheter
        </Heading>
        <Paragraph size={400} marginBottom={theme.spacing.xxs}>
          Under fanen "invester nå" finner du alle aktuelle emisjoner. Se om du finner noe som fremstår attraktivt for
          deg. Bruk diskusjonsforumet aktivt for å lære mer om selskapet.
        </Paragraph>
        <Link href='/kampanjer' fontSize={18} fontWeight={600} lineHeight='36px'>
          Se alle investeringsmuligheter
        </Link>
      </SmallInfoCard>
      <SmallInfoCard>
        <Heading size={medium ? 500 : 600} marginBottom={theme.spacing.xs}>
          3.
        </Heading>
        <Heading size={400} marginBottom={theme.spacing.xs}>
          Invester
        </Heading>
        <Paragraph size={400} marginBottom={theme.spacing.xxs}>
          Har du funnet et investerings- tilbud du liker? Under hvert enkelt investeringstilbud, kan du klikke på "kjøp
          aksjer" og registrere antall aksjer du vil kjøpe. Husk å kun investere det du har råd til å tape.
        </Paragraph>
        <Link href='/risiko' fontSize={18} fontWeight={600} lineHeight='36px'>
          Mer informasjon
        </Link>
      </SmallInfoCard>
    </Pane>
  )
}
